__turbopack_context__.v({
  "avatar": "DB1YpW_avatar",
  "content": "DB1YpW_content",
  "info": "DB1YpW_info",
  "modal": "DB1YpW_modal",
  "producer": "DB1YpW_producer",
  "title": "DB1YpW_title",
  "toggle-wrapper": "DB1YpW_toggle-wrapper",
});
